import { RemoteExportPendingActivitiesPerProfessionalPdf } from 'data/usecases';
import { ExportPendingActivitiesPerProfessionalPdfUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPendingActivitiesByProfessionalsExportPdf } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportPendingActivitiesPerProfessionalPdf =
  (): ExportPendingActivitiesPerProfessionalPdfUseCaseInterface =>
    new RemoteExportPendingActivitiesPerProfessionalPdf(
      makeApiUrlPendingActivitiesByProfessionalsExportPdf(),
      makeAxiosHttpClient(),
    );
